import styled from 'styled-components'

export const WidgetContainer = styled.div`
  background: ${props => props.theme.primaryBackgroundColor};
  overflow: hidden;
  width: 100%;
  padding: 36px 24px 24px;
  border-radius: 16px;
  border: 1px solid ${props => props.theme.primaryBorderColor};
`